import useStore from './_store';
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { useUserStore, usePageStore } from '@/store';

import signLog from '../../components/sign-log';


import { normal } from '../defaultSpacing';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';
export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-property-history'
    },
    data: function() {
        let config = {
            ...normal,
            title: '',
            needRegister: false
        };
        return {
            ...config,
            listingDetail: null,
            opened: false,
            getData: null
        };
    },
    asyncData: mapAsyncData(asyncData),
    computed: {

        ...rootMapState(usePageStore, {
            "page": store => store.page || {},
            "currencySymbol": store => store.currency?.symbol
        }),

        ...rootMapState(useUserStore, {
            "user": store => store.user
        }),

        ...mapState({
            "historys": store => store.historys,
            "source": store => store.source
        }),
        
        
        showPrevRecord() {
            return false; // if no data ， not displayed header
            return this.opened || this.historys.length <= 5;
        }
    },
    methods: {
        toggle() {
            if (!this.user && this.needRegister) {
                signLog.register({
                    onregister: () => {
                        this.opened = !this.opened;
                    },
                    onLogin() {
                        this.opened = !this.opened;
                    }
                });
            } else {
                this.opened = !this.opened;
            }
        }
    }
};
